jQuery(document).ready(function() {
  if (Shopify.Products) {
  	Shopify.Products.recordRecentlyViewed();
  }

    var offset = 220;
    var duration = 500;
    jQuery(window).scroll(function() {
        if (jQuery(this).scrollTop() > offset) {
            jQuery('#back-to-top').fadeIn(duration);
        } else {
            jQuery('#back-to-top').fadeOut(duration);
        }
    });

    jQuery('#back-to-top').click(function(event) {
        event.preventDefault();
        jQuery('html, body').animate({scrollTop: 0}, duration);
        return false;
    });
  	
//   	jQuery(window).scroll(function() {
//         var navigationPosition = jQuery('.site-header').outerHeight() + 50;
//         if(jQuery(window).scrollTop()>=navigationPosition){
//           jQuery('body').addClass('sticky-nav');
//         }else {
//           jQuery('body').removeClass('sticky-nav');
//         }
//     });
  
  //Code for product page
  jQuery(document).on('click', '.ds-view-size-chart', function() {
  	Swal.fire({
      title: 'Size Guide', 
      html: jQuery('#DS-modal-size-guild').html()
    });
  });

  jQuery(document).on('click', '.product-look-inside', function() {
    var content_html = '';
    jQuery('.product-gallery__link img').each(function(index) {
      if (index > 0 && jQuery(this).data('src')) {
        content_html += '<img src="' + jQuery(this).data('src') + '" class="lazyload lazyload--fade-in" />';
      }
    });

    if (content_html) {
      Swal.fire({
        title: 'Inside Pages', 
        html: content_html,
        cancelButtonText: 'Close',
        showCancelButton: true,
        showConfirmButton: false
      });
    }

    return false;
  });

  //Code for FAQ template
  jQuery('#faq-top-questions .faq-toc-title').html(jQuery('#template-page-faq .page__title').html());
  jQuery(document).on('click', '#faq-toc a', function() {
  	var targetEle = jQuery(this).data('ref');
    
    jQuery('#faq-toc a').removeClass('active');
    jQuery(this).addClass('active');
    
    jQuery('.faq-item-title').addClass('hide');
    jQuery('.faq-item-body').addClass('hide');
    
    jQuery(targetEle).removeClass('hide');
    jQuery(targetEle).prev('h2').removeClass('hide');

    var screenW = jQuery(window).width();
    if (screenW < 750) {
      jQuery('html, body').animate({scrollTop: 330}, duration);
    }

    var newUrl = window.location.protocol + '//' + window.location.host + window.location.pathname + targetEle;
    if (window.location.href != newUrl) {
      window.history.pushState('', '', window.location.protocol + '//' + window.location.host + window.location.pathname + targetEle);
    }

    return false;
  });
  jQuery('#template-page-faq .page__content h2').each(function(){
    var menuTitle = jQuery(this).text();
    menuTitle = jQuery.trim(menuTitle);
    if (menuTitle) {
      var uniMenuSlug = convertToSlug(menuTitle);
      jQuery('#faq-toc').append('<li><a href="javascript:void(0)" data-ref="#'+uniMenuSlug+'">'+menuTitle+'</a></li>');
      
      jQuery(this).addClass('faq-item-title hide');
	  jQuery(this).nextUntil('h2').wrapAll('<div id="'+uniMenuSlug+'" class="faq-item-body hide"></div>');
    }
  });
  
  jQuery('#template-page-faq .page__content h3').each(function(){
  	jQuery(this).append('<i class="uil uil-angle-right" style="float:right;"></i>');
    var itemSlugUni = convertToSlug(jQuery(this).text());
    jQuery(this).addClass('item-' + itemSlugUni);
  });
  
  jQuery(document).on('click', '#template-page-faq .page__content h3', function(){
    var iconCollapse = jQuery(this).find('i.uil');
    if (iconCollapse.hasClass('uil-angle-right')) {
      jQuery(this).nextUntil('h3', 'p').slideDown('slow', function(){
        iconCollapse.removeClass('uil-angle-right').addClass('uil-angle-down');
      });
      
    } else {
      jQuery(this).nextUntil('h3', 'p').slideUp('fast', function(){
        iconCollapse.removeClass('uil-angle-down').addClass('uil-angle-right');
      });
    }

    return false;
  });
  
  jQuery(document).on('click', 'li.kw-search-item', function(){
    var itemSlugUni = jQuery(this).data('slug');
    
    var parentEle = jQuery('.'+itemSlugUni).parents('.faq-item-body');
    var elementId = parentEle.attr('id');
    jQuery('[data-ref="#'+elementId+'"]').trigger('click');
    jQuery('#faq-suggest-search').hide();
    
    if (jQuery('.'+itemSlugUni).next().css('display') == 'none') {
      jQuery('.'+itemSlugUni).trigger('click');
    }
    
    var elementOffset = jQuery('.'+itemSlugUni).offset();
    jQuery('html, body').animate({scrollTop: (elementOffset.top - 150)});
  });

  var $content = jQuery('#template-page-faq .page__content');
  var inputSearchFaq = jQuery('#input-search-faq');
  inputSearchFaq.on('focus', function() {
    checkSearchSuggestItem();
  });
  inputSearchFaq.on('focusout', function() {
    jQuery('#faq-suggest-search').slideUp();
  });
  inputSearchFaq.on('input', function() {
  	var searchVal = this.value;
    var searchTmp = searchVal.split(' ');
    var searchKw = [];
    var faqSuggestSearch = jQuery('#faq-suggest-search');
    jQuery.each(searchTmp, function(index, value) {
      if (value.length >= 3) {
        searchKw.push(value);
      }
    });
    searchVal = searchKw.join(' ');
    
    $content.unmark({
      done: function() {
        $content.mark(searchVal, {
          separateWordSearch: true,
          done: function() {
            $results = $content.find('mark');
            faqSuggestSearch.html('');
            
            var searchClassWrapExists = [];
            jQuery.each($results, function() {
              var itemSlugUni = '';
              var htmlTmp = '';
              var parentEle = jQuery(this).parent();
              var parentTagName = parentEle.prop('tagName');
              if (parentTagName == 'H3') {
                itemSlugUni = convertToSlug(parentEle.text());
                htmlTmp += '<strong>' + parentEle.text() + '</strong><br>';
                htmlTmp += parentEle.next().text();
              } else if (parentTagName == 'P') {
                itemSlugUni = convertToSlug(parentEle.prev('h3').text());
                var parentEleHtml = parentEle.text();
                var itemIndexOf = parentEleHtml.indexOf(jQuery(this).text());
                
                htmlTmp += '<strong>' + parentEle.prev('h3').text() + '</strong><br>';
                htmlTmp += '...' + parentEleHtml.substring(itemIndexOf-10, itemIndexOf + 20) + '...';
              }
              
              if (itemSlugUni) {
                itemSlugUni = 'item-' + itemSlugUni;
              }
              
              if (itemSlugUni && _.indexOf(searchClassWrapExists, itemSlugUni) < 0) {
                searchClassWrapExists.push(itemSlugUni);
                
                if (htmlTmp) {
                  faqSuggestSearch.append('<li class="kw-search-item" data-slug="'+itemSlugUni+'">'+htmlTmp+'</li>');
              	}
              }
            });
          }
        });
      }
    });
    
    checkSearchSuggestItem();
  });
  if (jQuery('#faq-toc').length > 0) { // check is FAQ page
    var curentUrl = window.location.href;
    var screenW = jQuery(window).width();

    if (curentUrl.indexOf('#') > 0 && screenW < 750) {
      var currentUrlArray = curentUrl.split('#');
      jQuery('[data-ref="#'+currentUrlArray[1]+'"]').trigger('click');
    } else {
      jQuery('#faq-toc a:eq(0)').trigger('click');
    }
  }

  if (Shopify.Products) {
    Shopify.Products.showRecentlyViewed({
      howManyToShow: 4,
      onComplete: function() {
          jQuery('#rv-products-wrap').show();
      }
    });
  }

  //Code Footer
//   jQuery('h5.footer_title').each(function(){
//   	jQuery(this).append('<i class="uil uil-angle-right" style="float:right;"></i>')
//   });
  
//   jQuery(document).on('click', 'h5.footer_title', function(){
//     var iconCollapse = jQuery(this).find('i.fa');
//   	var screenW = jQuery(window).width();
//     if (screenW < 750) {
//       if (iconCollapse.hasClass('fa-angle-right')) {
//         jQuery(this).next('.toggle_content').slideDown('slow', function(){
//           iconCollapse.removeClass('fa-angle-right').addClass('fa-angle-down');
//       	});
//       } else {
//         jQuery(this).next('.toggle_content').slideUp('fast', function(){
//           iconCollapse.removeClass('fa-angle-down').addClass('fa-angle-right');
//       	});
//       }
//     }
    
//     return false;
//   });

  jQuery(document).on('click touchend', '.product-jump-reviews', function(event) {
    event.preventDefault();
    location.href = "#judgeme_product_reviews"; 
    //location.href = "#looxReviews"; 
  });

   jQuery(document).on('click touch', '#sps-see-more', function(){
      if ($(this).text() === 'See More') {
        $('.sps-short-description').hide();
        $('.sps-full-description').slideDown();
        $(this).text('See Less');
      } else {
        $('.sps-short-description').show();
        $('.sps-full-description').slideUp();
        $(this).text('See More');
      }
  });

  if (typeof uni_product_tag !== 'undefined' && uni_product_tag.length > 0) {
    jQuery.each(uni_product_tag, function(index, item) {
        uniGroupLoad(item, uni_product_id);
    });
  }
});

function convertToSlug(Text) {
    return Text
        .toLowerCase()
        .replace(/ /g,'-')
        .replace(/[^\w-]+/g,'');
}

function checkSearchSuggestItem() {
  var faqSuggestSearch = jQuery('#faq-suggest-search');
  if (faqSuggestSearch.find('li').length > 0) {
    faqSuggestSearch.show();
  } else {
    faqSuggestSearch.hide();
  }
}

function uniGroupLoad(tag, product_id) {
  let requestUrl = '/collections/all/' + tag + '?view=json';
  let request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
          let products = JSON.parse(request.response);

          // Sort products A-Z
          products.sort(function(a, b){
            if(a.title < b.title) { return -1; }
            if(a.title > b.title) { return 1; }
            return 0;
          });

          // loop through each product
          jQuery.each(products, function(key, product) {
              jQuery('#ProductGroupDropdown').append(
                  jQuery("<option></option>").attr("value", product.id).attr("data-url", product.url).text(product.title)
              );
          });
          jQuery('#ProductGroupDropdown').val(product_id);
          jQuery('#ProductGroupDropdown').change(function() {
              var url = jQuery("#ProductGroupDropdown option:selected")[0].attributes['data-url'].value;
              location.href = url;
          });

          if (products.length > 1) {
              jQuery('#ProductGroupDS').removeClass('hide');
              jQuery('.ds-product-group-' + product_id).addClass('active');
          }
      };
  };
  request.send();
}